import React, { CSSProperties, useId } from 'react';
import Button from 'components/Button';
import cx from 'classnames';

import './DropdownMenu.scss';

export interface DropdownMenuAction {
  icon: JSX.Element;
  onClick?: () => void;
  text: string;
  hidden?: boolean;
  disabled?: boolean;
  disabledReason?: string;
}

interface DropdownMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  actions: Array<DropdownMenuAction & { customStyles?: CSSProperties }>;
  className?: string;
}

const DropdownMenu = ({ actions, className, ...rest }: DropdownMenuProps) => {
  const descriptionId = useId();
  const activeActions = actions.filter(
    action => !action.hidden && action.onClick
  );

  return (
    <div className={cx('dropdown-menu-wrapper', className)} {...rest}>
      {activeActions.map((action, index) => (
        <div key={action.text}>
          <Button
            className="unstyled-button"
            icon={action.icon}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              action.onClick?.();
            }}
            disabled={action.disabled}
            aria-describedby={
              action.disabled && action.disabledReason
                ? `${descriptionId}-${index}`
                : undefined
            }
            style={action.customStyles}
            onDrag={e => e.stopPropagation()}
            fontWeight="normal"
            alignment="left"
          >
            {action.text}
          </Button>
          {action.disabled && action.disabledReason && (
            <p
              id={`${descriptionId}-${index}`}
              className="dropdown-menu-disabled-reason"
            >
              {action.disabledReason}
            </p>
          )}
          {activeActions.length - 1 > index && <hr />}
        </div>
      ))}
    </div>
  );
};

export default DropdownMenu;
